<app-top-bar [formControl]="darkModeControl"></app-top-bar>
<main class="content min-h-screen min-w-72 p-8 pb-11 sm:p-16">
  <router-outlet></router-outlet>
  <button mat-fab class="contact-button" (click)="openContactForm()">
    <mat-icon class="contact-button--icon">message</mat-icon>
  </button>
</main>
<app-footer></app-footer>
